import React from "react";
import PropTypes from "prop-types";

const CompanyInventorySearch = ({
  searchBy,
  setSearchValue,
  setSearchBy,
  searchValue
}) => (
  <div className="company-inventory-search-container">
    <select
    className="company-inventory-select"
      value={searchBy}
      onChange={({ target }) => {
        setSearchBy(target.value);
        setSearchValue("");
      }}
    >
      <option value="serial_number">Serial Number</option>
      <option value="model_number">Model Number</option>
      <option value="name">Name</option>
    </select>
    <input
      placeholder="Search..."
      value={searchValue}
      onChange={({ target }) => {
        setSearchValue(target.value);
      }}
      className="company-inventory-search-input"
    />
  </div>
);

CompanyInventorySearch.propTypes = {
  searchBy: PropTypes.string.isRequired,
  setSearchValue: PropTypes.func.isRequired,
  setSearchBy: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired
};

export default CompanyInventorySearch;